import { choices, number, RadioButtonGroupInput, required } from "react-admin";

const validateType = [
  required(),
  number(),
  choices([1, 2, 3, 4], "Please choose one of the values"),
];

const RadioGroupX = ({ choices, ...props }) => {
  return (
    <RadioButtonGroupInput
      fullWidth
      source="type"
      label="mine.label.type"
      parse={(value) => (value === "" ? null : +value)}
      // format={(value) => (value == null ? "" : +value)}
      // defaultValue={1}
      choices={choices}
      validate={validateType}
      {...props}
      // row={false}
      sx={{
        overflow: "hidden",
        // "&>label": { borderBottom: "solid 1px rgba(0,0,0,0.2)" },
      }}
    />
  );
};

export default RadioGroupX;
